const githubReducer = (state, action) => {
    switch (action.type) {
        case 'GET_REPOS':
            return {
                ...state,
                repos: action.payload,
                loading: false
            }
        case "SET_LOADING":
            return {
                ...state,
                loading: true,
            }
        default:
            return state;
    }
}


export default githubReducer;